
import {Component, Vue} from 'vue-property-decorator';
import NotificationsManager from '@/components/NotificationsManager.vue';
import UploadProgressDialog from '@/components/UploadProgressDialog.vue';
import {readIsLoggedIn} from '@/store/main/getters';
import {dispatchCheckLoggedIn} from '@/store/main/actions';
import loading from 'vue-full-loading';
import AppEvents from './events';

@Component({
  components: {
    NotificationsManager, UploadProgressDialog, loading,
  },
})
export default class App extends Vue {

  get loggedIn() {
    return readIsLoggedIn(this.$store);
  }

  public isLoading: boolean = false;

  public async mounted() {
    // @ts-ignore
    this.$eventBus.$on('SHOW_LOADING', this.loadingEventListener);
  }

  public async created() {
    await dispatchCheckLoggedIn(this.$store);
    // @ts-ignore
    AppEvents.forEach((item) => {
      this.$on(item.name, item.callback);
    });
    // @ts-ignore
    window.getApp = this;
    // @ts-ignore
    window.getApp.lang = this.$t;
  }

  private loadingEventListener(isLoading: boolean) {
    this.isLoading = isLoading;
  }
}
